import { createFileRoute, Navigate, Outlet, useLocation } from "@tanstack/react-router";
import { OnboardingProvider } from "@/features/onboarding/OnboardingContext";
import { OnboardingLayout, STEPS } from "@/features/onboarding/OnboardingLayout";
import { useAuth } from "@/hooks/useAuth";

export const Route = createFileRoute("/(public)/onboarding")({
  component: OnboardingParent,
});

function OnboardingParent() {
  const location = useLocation();
  const { user, isAuthenticated, isLoading } = useAuth();
  const currentStep = STEPS.findIndex((s) => location.pathname === s.to);

  // Onboarding is only for an authenticated user whose org still needs setup.
  // Once setup is complete (or for super admins, who never onboard), the page
  // is off-limits — send them into the app instead.
  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const isSuperAdmin = user?.permissions?.includes("*:*") ?? false;
  const setupComplete = user?.organization?.setupCompleted === true;
  if (isSuperAdmin || setupComplete) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <OnboardingProvider>
      <OnboardingLayout currentStep={currentStep === -1 ? 0 : currentStep}>
        <Outlet />
      </OnboardingLayout>
    </OnboardingProvider>
  );
}
